import React from 'react';
import { Card } from 'react-bootstrap';

const DemoStats = () => (
  <>
    <Card className="shadow-sm mb-3">
      <Card.Body>
        <Card.Title>Total Orders</Card.Title>
        <h4>4000</h4>
      </Card.Body>
    </Card>
    <Card className="shadow-sm mb-3">
      <Card.Body>
        <Card.Title>Total Sales</Card.Title>
        <h4>$123,000</h4>
      </Card.Body>
    </Card>
  </>
);

export default DemoStats;
